/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fg } from '@atlassian/jira-feature-gating';

// Legacy fields
export function isReactCompilerForLegacySimpleFieldsEnabled(): boolean {
	return true;
}

// Most Rendered Packages Feature Gates
export function isReactCompilerForMostRenderedPackagesEnabled(): boolean {
	if (fg('jiv_react_compiler_for_most-rendered_components')) {
		return true;
	}
	return false;
}

// NIN packages opt-out
// These packages have React Compiler errors causing NIN transition regressions.
// Excluded until underlying issues are resolved:
// - @jira/issue-table__features (highest impact)
// - @atlassian/jira-issue-navigator
// - @jira/issue-table__inline-create-filter-context
// - @jira/issue-table__data-loader-scheduler
export function isReactCompilerForNINPackagesEnabled(): boolean {
	if (fg('jiv_react_compiler_for_nin_packages')) {
		return true;
	}
	return false;
}
